/**
 * Light report theme for SCMI Daily Report PDF content slides.
 */
export const REPORT_PRINT_THEME = {
  background: '#ffffff',
  backgroundAlt: '#f8fafc',
  backgroundMuted: '#f1f5f9',
  text: '#111827',
  textMedium: '#374151',
  textLight: '#6b7280',
  border: '#e5e7eb',
  borderDark: '#d1d5db',
  accent: '#f9be0b',
  accentDark: '#d97706',
  headerBg: '#1f2937',
  headerText: '#ffffff',
  success: '#059669',
  info: '#0891b2',
  warning: '#d97706',
  purple: '#7c3aed',
  indigo: '#4f46e5',
  danger: '#dc2626',
};

export const REPORT_PRINT_TYPO = {
  pageTitle: { fontSize: '20px', fontWeight: 700 },
  sectionTitle: { fontSize: '14px', fontWeight: 700 },
  label: { fontSize: '10px', fontWeight: 600 },
  body: { fontSize: '11px', fontWeight: 400 },
  kpiValue: { fontSize: '18px', fontWeight: 700 },
  kpiLabel: { fontSize: '9px', fontWeight: 600 },
  footnote: { fontSize: '9px', fontWeight: 400 },
};

export default REPORT_PRINT_THEME;
